import { TimeUtils } from '@colonist/utils';
export function formatShuffleQueueTimeLeft(date) {
    const now = new Date();
    const milliseconds = date.getTime() - now.getTime();
    const totalSeconds = milliseconds / TimeUtils.MILLISECONDS;
    const days = totalSeconds / TimeUtils.SECONDS_IN_DAY;
    if (days >= 1) return {
        key: 'strings:colonistCommon.timeLeft.days',
        options: {
            count: Math.floor(days)
        }
    };
    const hours = totalSeconds / TimeUtils.SECONDS_IN_HOUR;
    if (hours >= 1) return {
        key: 'strings:colonistCommon.timeLeft.hours',
        options: {
            count: Math.floor(hours)
        }
    };
    const minutes = totalSeconds / TimeUtils.SECONDS_IN_MINUTE;
    if (minutes >= 1) return {
        key: 'strings:colonistCommon.timeLeft.minutes',
        options: {
            count: Math.floor(minutes)
        }
    };
    const seconds = totalSeconds % TimeUtils.SECONDS_IN_MINUTE;
    if (seconds >= 1) return {
        key: 'strings:colonistCommon.timeLeft.seconds',
        options: {
            count: Math.floor(seconds)
        }
    };
    return {
        key: 'strings:homePage.matchmakingSelect.newQueueSoon'
    };
}
